import React, { useState, useEffect, useContext } from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../Assets/logo.png";
import { AiOutlineHome, AiOutlineUser, AiOutlineFundProjectionScreen, AiFillStar } from "react-icons/ai";
import { CgFileDocument } from "react-icons/cg";

import { CgGitFork } from "react-icons/cg";
// import { ImBlog } from "react-icons/im";
import { FaSun, FaMoon } from 'react-icons/fa';
import { ThemeContext } from "./ThemeContext";


function NavBar() {
  const [expand, setExpand] = useState(false);
  const [navColour, setNavColour] = useState(false);
  const { theme, toggleTheme } = useContext(ThemeContext);

  useEffect(() => {
    const handleScroll = () => setNavColour(window.scrollY >= 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={`${navColour ? "sticky" : "navbar"} ${expand ? "mobile-fullscreen" : ""}`}
  //     style={expand ? {
  //       position: 'fixed',
  //       top: 0,
  //       left: 0,
  //       width: '100vw',
  //       height: '100vh',
  //       backgroundColor: 'var(--bs-body-bg)',
  //       zIndex: 1030
  // } : {}}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img src={logo} alt="brand" className="img-fluid logo" />
        </Navbar.Brand>

        <Navbar.Toggle
          onClick={() => setExpand(expand ? false : "expanded")}
          aria-controls="basic-navbar-nav"
        >
          <span />
          <span />
          <span />
        </Navbar.Toggle>

        <Navbar.Collapse>
          <Nav className="ms-auto">
            <Nav.Item>
              <Nav.Link as={Link} to="/" onClick={() => setExpand(false)}>
                <AiOutlineHome /> Home
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link as={Link} to="/about" onClick={() => setExpand(false)}>
                <AiOutlineUser /> About
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link as={Link} to="/project" onClick={() => setExpand(false)}>
                <AiOutlineFundProjectionScreen /> Projects
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link as={Link} to="/resume" onClick={() => setExpand(false)}>
                <CgFileDocument /> Resume
              </Nav.Link>
            </Nav.Item>

            {/* <Nav.Item>
              <Nav.Link
                // href="https://soumyajitblogs.vercel.app/"
                href="https://cmssite22.000webhostapp.com/"
                target="_blank"
                rel="noreferrer"
              >
                <ImBlog style={{ marginBottom: "2px" }} /> Blogs
              </Nav.Link>
            </Nav.Item> */}

            <Nav.Item className="fork-btn">
              <Button
                href="https://github.com/malikar1"
                target="_blank"
                className="fork-btn-inner bg-transparent"
              >
                <CgGitFork style={{ fontSize: "1.2em" }} />{" "}
                <AiFillStar style={{ fontSize: "1.1em" }} />
              </Button>
            </Nav.Item>
            <Nav.Item className="d-flex align-items-center justify-content-center mb-2">
              <Button
                variant={theme === "light" ? "outline-dark" : "outline-light"}
                className="rounded-circle"
                onClick={toggleTheme}
                style={{
                  marginTop:'4px',
                  width: '30px',
                  height: '30px',
                  padding: '0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #239af5',
                  background: 'transparent'
                }}
              >
                {theme === "light" ? (
                  <FaSun size={16} color="#f59f00" />
                ) : (
                  <FaMoon size={16} color="#495057" />
                )}
              </Button>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
